"use client";

import { useParams, usePathname } from "next/navigation";
import { resolveCurrentLocale, type LocaleCode } from "@/utils/localize-path";

// Locale of the current route: [lang] param first, pathname prefix as fallback.
export default function useCurrentLocale(): LocaleCode {
  const params = useParams();
  const pathname = usePathname();
  return resolveCurrentLocale(params?.lang, pathname);
}
